<template>
    <div class="e-ejercicio">
      <div class="e-ejercicio-descripcion text-xs-left">
        <p class="instruccion mb-2" v-html="loadedLessons.instructions_spanish"></p>
      </div>
      <div class="e-ejercicio-ejercicio  pt-2">
        <v-layout  pt-0 column>
            <v-flex xs12 px-3>
                <v-card class="e-pregunta mb-5">
                    <v-card-text class="p-normal pa-5 fill-height align-center d-flex text-xs-center justify-center">
                        {{ loadedLessons.exercise }}
                    </v-card-text>
                    <v-card-actions class="text-xs-center justify-space-around">
                        <v-btn fab large color="success" style="width: 72px !important" @click="seleccionarRespuesta('true')">
                        <v-icon>check</v-icon>
                        </v-btn>
                        <v-btn fab large color="error" style="width: 72px !important" @click="seleccionarRespuesta('false')">
                        <v-icon>close</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
      </div>
    </div>
</template>

<script>
import CardPregunta from '../intermedio/CardPregunta'

export default {
  name: 'CardPreguntaFinal',
  components: {
    CardPregunta
  },
  props: {
    loadedLessons: {
      type: Object,
      default: {
        instructions_spanish: '',
         exercise: '',
         answer: ''
      }
    },
    currenStep: {
      type: Number
    }
  },
  methods: {
    seleccionarRespuesta(value) {
      const valueSelected = {
        answer: this.loadedLessons.answer,
        userAnswer: value,
        currenStep: this.currenStep
      }
      this.$emit('clicked', valueSelected)
    }
  }
}
</script>